import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AuthProvider from './AuthProvider';
import messages from './assets/lang';
import Atoms from './providers/Atoms';

if (+process.env.REACT_APP_SENTRY_ENABLED) {
  Sentry.init({
    debug: !!+process.env.REACT_APP_SENTRY_DEBUG,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    integrations: [new Integrations.BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
    // Sentry.io recommend adjusting this value in production
    tracesSampleRate: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    {/* We don't have any localised messages specific to this application or the ability to switch locales yet...
	  so hard coded to en-GB for now, and we're just using the component library's lang file. */}
    <IntlProvider messages={messages} defaultLocale="en-GB" locale="en-GB">
      <BrowserRouter>
        <Atoms>
          <AuthProvider>
            <App />
          </AuthProvider>
        </Atoms>
      </BrowserRouter>
    </IntlProvider>
  </React.StrictMode>,
);
